import React from 'react';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import log from "loglevel";
import "./QuizMenu.css";

export default function QuizMenu() {
    // ----- Log Level Configuration -----
    log.setLevel(process.env.REACT_APP_LOG_LEVEL || "info");

    const [selectedFile, setSelectedFile] = useState(null);
    const [isOn, setIsOn] = useState(false);
    const [quizInfos, setQuizInfos] = useState([]);

    useEffect(() => {
        // อ่านไฟล์ menu.json จากโฟลเดอร์ public
        fetch('/menu.json')
            .then((response) => response.json()) // แปลงให้เป็น JSON format
            .then((data) => setQuizInfos(data.quizInfos))
            .catch((error) => log.error(`Error fetching quiz informations:`, error));
    }, []);

    // Handle retest file selection
    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        log.debug(`Selected file :${selectedFile}`);

        if (selectedFile && selectedFile.type === "application/json") {
            log.debug(`Selected file :${selectedFile.type}`);
            const reader = new FileReader(selectedFile);

            reader.onload = (e) => {
                try {
                    const parsedJson = JSON.parse(e.target.result);
                    log.debug(`JSON Data: ${JSON.stringify(parsedJson, null, 2)}`);

                    let quizFile = parsedJson.quizFile;
                    let quizMode = "PRACTICE";

                    window.location.href = `/quizGame/${quizFile}/${quizMode}?wrong=${parsedJson.wrong}`;
                } catch (error) {
                    log.error(`Invalid JSON file`, error);
                }
            };
            reader.readAsText(selectedFile);
        };
    }

    const handleMenuClick = (quizFile) => {
        window.location.href = `/quizGame/${quizFile}/${isOn ? "TEST" : "PRACTICE"}`;
    }

    return (
        <div>
            {/* Toggle Mode Button */}
            <label className="menu-label"
                onClick={() => setIsOn(!isOn)}
            >
                Mode: {isOn ? "ทดสอบ" : "ฝึกฝน"}
            </label>

            <p />

            {/* File Input */}
            <label className="menu-label">
                {selectedFile ? selectedFile : "เลือกไฟล์ที่ต้องการทดสอบซ้ำ"} {/* Change button text */}
                <input type="file" onChange={handleFileChange} />
            </label>

            {/* Quiz Links */}
            <ul className="menu-list-ul">
                {quizInfos.map((quizInfo, index) => (
                    <li key={index} className={quizInfo.style ? quizInfo.style : "menu-list-li"} onClick={() => handleMenuClick(quizInfo.file)}>
                        {quizInfo.name} {isOn ? "ทดสอบ" : "ฝึกฝน"}
                    </li>
                ))}
            </ul>
        </div>
    );
};